import React, { useEffect } from "react";
import { getNotesPack, selectNotesPacks } from "../../../../api/plans";
import styled from "styled-components";
import { formatDate, formatCurrencyValue, decimalFormat, supportPhoneNumber } from "../../../../utils";
import AppContext from "../../context";
import LoadingContainer from "../../../../_components/LoadingContainer";
import Modal from "../../../../_components/Modal";
import { toast } from "react-toastify";
import IconButton from "../../../../_components/Button/IconButton";
import { useShowNoteButton } from "./hooks";
import CardUpgrade from "../CardUpgrade/";
import { useLocation } from "react-router-dom";

const BoxWrapper = styled.div``;

const PeriodTitle = styled.p`
  text-align: center;
  font-weight: 600;
  font-size: 1.4em;
  margin-top: 20px;
`;

const NotePackWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  border-radius: 10px;
  margin-bottom: 10px;
  background-color: #1ab394;
  padding: 10px;
  color: white;
  font-weight: bold;
  font-size: 1.3em;

  @media (max-width: 500px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    min-height: 100px;
  }
`;

const TextTitle = styled.p`
  text-align: center;
  font-size: 1.5em;
  font-weight: bold;
  color: #2554b8;
`;

const DangerTextTitle = styled.p`
  text-align: center;
  font-size: 1.5em;
  font-weight: bold;
  color: #e22126;
`;

const TextWarning = styled.p`
  text-align: left;
  font-size: 1.1em;
`;

const LabelMoreNotes = styled.p`
  text-align: center;
  font-size: 1.1em;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 20px;
`;

export default function ComprarNotasAvulsas(props) {
  const context = React.useContext(AppContext);
  const ref = React.useRef(null);
  const handleShowMe = useShowNoteButton();
  const location = useLocation();

  const [showAvulsaGratis, setShowAvulsaGratis] = React.useState(false); 
  const [showAvulsaRegra, setShowAvulsaRegra] = React.useState(false);   
  const [showUpgrade, setShowUpgrade] = React.useState(false);           

  const [active, setActive] = React.useState(false);
  const [packs, setPacks] = React.useState([]);
  const [messageCheck, setMessageCheck] = React.useState({});
  const [fetchingPacks, setFetchingPacks] = React.useState(false);
  const [clickedButtonId, setClickedButtonId] = React.useState(null);
  const [requestStatus, setRequestStatus] = React.useState(false);

  const freePlanId = "89723c2c-64d1-40b4-9806-1aa433f91645";

  function clickParagraph() {
    window.open(
      `https://api.whatsapp.com/send?phone=+${supportPhoneNumber}&text=Ol%C3%A1,%20minhas%20notas%20acabaram,%20gostaria%20de%20conhecer%20os%20planos.`,
      "__blank"
    );
  }

  function onHideAvulsaGratis() {
    setShowAvulsaGratis(false);
  }
  function onHideAvulsaRegra() {
    setShowAvulsaRegra(false);
  }

  function isPlanFree(branch_plan) {
    const name = (branch_plan.plan_name || "").toUpperCase();
    return (
      branch_plan.plan === freePlanId ||
      name === "GRÁTIS" ||
      name === "GRATUITO+"
    );
  }

  async function getAndOrderNotesPack() {
    const { branch_plan } = context.currentBranch;

    setMessageCheck({
      plan_name: branch_plan.plan_name,
      end_date: branch_plan.end_date,
      plan: branch_plan.plan,
    });

    if (props.disabled === true || branch_plan.status !== 1) {
      toast.error("Plano inativo ou bloqueado para compras de notas.", {
        position: "top-center",
      });
      return;
    }

    if (props.onClick) props.onClick();

    setFetchingPacks(true);

    let data = [];
    try {
      data = await getNotesPack();
    } catch (error) {
      console.error("Erro ao buscar packs:", error);
      setFetchingPacks(false);
      toast.error("Não foi possível carregar os pacotes de notas.");
      return;
    }

    if (!isPlanFree(branch_plan)) {
      data = data.filter((pack) => pack.notes_quantity <= 10);
    }

    const periodsDays = [];
    for (let pack of data) {
      if (!periodsDays.includes(pack.days_to_expire)) {
        periodsDays.push(pack.days_to_expire);
      }
    }

    const orderedPacks = [];
    for (let period of periodsDays) {
      const filter = data.filter((pack) => pack.days_to_expire === period);
      orderedPacks.push({ period, data: filter });
    }

    setPacks(orderedPacks);

    setTimeout(() => {
      setFetchingPacks(false);
      setShowUpgrade(true);
    }, 300);
  }

  function handleSelectNotesPack(e) {
    const planId = context.currentBranch.branch_plan.plan;

    if (planId !== freePlanId) {
      const nowLocal = new Date();
      const currentDate = new Date(
        nowLocal.getFullYear(),
        nowLocal.getMonth(),
        nowLocal.getDate()
      ); 
      const end = new Date(context.currentBranch.branch_plan.end_date);
      const endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate());

      if (endDate < currentDate) {
        toast.error(
          "O plano está expirado ou inativo. Por favor, renove seu plano.",
          {
            position: "top-center",
            toastId: "additional-notes-locked",
          }
        );
        return;
      }
    }

    const { id } = e.target;
    setClickedButtonId(id);
    setRequestStatus(true);

    selectNotesPacks({ notes_pack: id }, props.branchOwnerId)
      .then((data) => {
        window.open(data.invoice_url, "__blank");
        window.location.href = "/plan/branch-invoices";
      })
      .catch(() => {
        toast.error("Não foi possível iniciar a compra deste pacote.");
        setRequestStatus(false);
        setClickedButtonId(null);
      });
  }

  useEffect(() => {
    setActive(handleShowMe(context, location.pathname));
  }, [context.currentBranch, location.pathname]);

  if (!active) {
    return <span />;
  }

  const { branch_plan } = context.currentBranch;
  const isFree = isPlanFree(branch_plan);

  return (
    <div className="row">
      {props.planplan === "b85046a1-3803-4ee4-a858-8ef2c26d9d76" ? (
        <IconButton
          type="white"
          ref={ref}
          onClick={getAndOrderNotesPack}
          label={`ILIMITADAS`}
          icon="fas fa-receipt"
        />
      ) : (
        <IconButton
          type="white"
          ref={ref}
          onClick={getAndOrderNotesPack}
          label={`${props.quantity}`}
          icon="fas fa-receipt"
        />
      )}

      <CardUpgrade
        hideButton
        open={showUpgrade}
        onRequestClose={() => setShowUpgrade(false)}
        onSwitchToAvulso={() => {
          setShowUpgrade(false);
          if (isFree) {
            setShowAvulsaGratis(true);
          } else {
            setShowAvulsaRegra(true);
          }
        }}
      />

      <Modal title="Adquira mais notas" show={showAvulsaGratis} size="md" onHide={onHideAvulsaGratis}>
        <LoadingContainer loading={fetchingPacks}>
          <BoxWrapper>
            <TextTitle>Notas avulsas disponíveis</TextTitle>

            <div>
              <TextWarning>
                <strong>*Importante</strong>: Qualquer compra de nota(s) avulsa(s)
                deve ser compreendida como emergencial e não substitui um plano mensal.
              </TextWarning>
              <TextWarning>
                Plano mensal ativo: {messageCheck.plan_name}.
                <br />
                Próximo vencimento: {formatDate(messageCheck.end_date)}.
              </TextWarning>
            </div>

            {packs.map((pack) => {
              return (
                <div key={`period-${pack.period}`}>
                  <PeriodTitle>{pack.period} dias de validade</PeriodTitle>
                  {pack.data.map((indiviualPack) => {
                    const label =
                      indiviualPack.notes_quantity > 1
                        ? `${indiviualPack.notes_quantity} notas avulsas`
                        : `${indiviualPack.notes_quantity} nota avulsa`;
                    const value = formatCurrencyValue(decimalFormat(indiviualPack.price));
                    return (
                      <NotePackWrapper key={`additional-package-id-${indiviualPack.id}`}>
                        <span>{label}</span>
                        <span>{value}</span>
                        <button
                          className="btn btn-secondary"
                          onClick={handleSelectNotesPack}
                          id={indiviualPack.id}
                          disabled={requestStatus}
                          aria-label={`Comprar ${label} por ${value}`}
                        >
                          {indiviualPack.id === clickedButtonId ? "Finalizando ..." : "Comprar"}
                          {indiviualPack.id === clickedButtonId ? (
                            <i className="fas fa-spinner fa-spin ml-2" />
                          ) : (
                            <span />
                          )}
                        </button>
                      </NotePackWrapper>
                    );
                  })}
                </div>
              );
            })}
          </BoxWrapper>
          <LabelMoreNotes onClick={clickParagraph}>Quero adquirir mais notas</LabelMoreNotes>
        </LoadingContainer>
      </Modal>

      <Modal title="Adquira mais notas" show={showAvulsaRegra} size="md" onHide={onHideAvulsaRegra}>
        <LoadingContainer loading={fetchingPacks}>
          <BoxWrapper>
            <DangerTextTitle>Atenção!</DangerTextTitle>

            <div>
              <TextWarning className="text-center">
                Notas avulsas só podem ser compradas até a <strong>data de vencimento</strong> do seu plano atual.
              </TextWarning>
              <TextWarning className="text-center">
                Qualquer pacote adquirido irá expirar na mesma data do seu vencimento,{" "}
                <strong>sem a possibilidade de acúmulo para períodos futuros.</strong> Qualquer dúvida, entre em contato com nosso{" "}
                <a href={`https://api.whatsapp.com/send/?phone=${supportPhoneNumber}`} target="_blank" rel="noreferrer">
                  atendimento
                </a>{" "}
                via WhatsApp.
              </TextWarning>
              <TextWarning>
                Plano mensal ativo: {messageCheck.plan_name}.
                <br />
                Próximo vencimento: {formatDate(messageCheck.end_date)}.
              </TextWarning>
            </div>

            {packs.map((pack) => {
              return (
                <div key={`period-${pack.period}`}>
                  {pack.data.map((indiviualPack) => {
                    const label =
                      indiviualPack.notes_quantity > 1
                        ? `${indiviualPack.notes_quantity} notas avulsas`
                        : `${indiviualPack.notes_quantity} nota avulsa`;
                    const value = formatCurrencyValue(decimalFormat(indiviualPack.price));
                    return (
                      <NotePackWrapper key={`additional-package-id-${indiviualPack.id}`}>
                        <span>{label}</span>
                        <span>{value}</span>
                        <button
                          className="btn btn-secondary"
                          onClick={handleSelectNotesPack}
                          id={indiviualPack.id}
                          disabled={requestStatus}
                          aria-label={`Comprar ${label} por ${value}`}
                        >
                          {indiviualPack.id === clickedButtonId ? "Finalizando ..." : "Comprar"}
                          {indiviualPack.id === clickedButtonId ? (
                            <i className="fas fa-spinner fa-spin ml-2" />
                          ) : (
                            <span />
                          )}
                        </button>
                      </NotePackWrapper>
                    );
                  })}
                </div>
              );
            })}
          </BoxWrapper>
          <LabelMoreNotes onClick={clickParagraph}>Quero adquirir mais notas</LabelMoreNotes>
        </LoadingContainer>
      </Modal>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/NotesQuantityIcon/index.jsx